import api from "../utils/api";

export const getRetrieveMembership = async customerNumber => {
  try {
    const res = await api.leads.retrieveMembership({ customerNumber: customerNumber });
    return res?.data;
  } catch (err) {
    return err.obj;
  }
};